<template>
  <div class="teacherHome">
    <div>
      <div @click="$router.push('/classList')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          課程列表
        </div>
      </div>
      <div @click="$router.push('/allQuestions')">
        <div>
          <img src="../assets/image/studentList.png" />
        </div>
        <div>
          學生問題
        </div>
      </div>
    </div>

    <Loading />
  </div>
</template>

<script>
import Loading from '../components/Loading.vue';

export default {
  name: 'TeacherHome',
  components: {
    Loading,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.teacherHome {
  > div {
    display: flex;
    padding: 55px 8%;

    @media (max-width: 480px){
      flex-direction: column;
      padding: 35px 8%;
    }

    > div {
      flex: 1;

      border-radius: 20px;
      box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.5);
      border: solid 3px #000000;
      background-color: #ffffff;
      padding: 20px;
      transition: all .3s;
      cursor: pointer;

      &:hover {
        transition: all .3s;
        background: $main-yellow;
      }

      &:first-child {
        margin-right: 64px;

        @media (max-width: 480px){
          margin-right: 0;
          margin-bottom: 30px;
        }
      }

      > div {
        &:first-child {
          text-align: center;
          border-bottom: 1px solid #000;
          img {
            width: 85%;
          }
        }

        &:nth-child(2) {
          font-size: 30px;
          text-align: center;
          color: #000;

          padding: 20px 0 10px;
        }
      }
    }
  }
}
</style>
